import { initRecommendedSwiper, initProductTileSwiper } from 'plugin_frontend_components/components/sliders';
const CONST = require('plugin_frontend_core/constants');

const selectors = {
    productCarousel: '.js-product-carousel-container:not(.swiper-container-initialized)',
    cQuotientProductCarousel: '.js-cquotient-noanchor-product-carousel:not(.swiper-container-initialized)',
    cQuotientProductCarouselContainer: '.product-carousel-einstein'
};

let cqItvIndex = 0;
let CQuotientInterval;
/**
 * initCQuotient
 * Einstein adds recommendations client side after dom load. Since there is no callback from this that we can use, we need
 * to set an interval to check when it has been added.
 */
function initCQuotient() {
    initRecommendedSwiper();
    initProductTileSwiper();

    $('body').on(CONST.events.einsteinLoaded, function (event, data) {
        var $element = $(data.parent);
        var $container = $element.closest(selectors.cQuotientProductCarouselContainer);
        $container.removeClass('d-none');
        $('body').trigger(CONST.events.einsteinLoadedGtm);
    });

    cqItvIndex = 0;
    clearInterval(CQuotientInterval);

    CQuotientInterval = setInterval(function CQuotientIntervalCheck() {
        cqItvIndex++;
        const $productCarousel = $(selectors.productCarousel);

        if ($productCarousel.length > 0) {
            initRecommendedSwiper();
            initProductTileSwiper();
            clearInterval(CQuotientInterval);
            return;
        }

        if (cqItvIndex === 10) {
            clearInterval(CQuotientInterval);
        }
    }, 500);
}

/**
 * Initializes the file
 */
function init() {
    $(document).ready(initCQuotient);
}

export { init };
